import { render, staticRenderFns } from "./TextFilter.vue?vue&type=template&id=8587e224&"
import script from "./TextFilter.vue?vue&type=script&lang=js&"
export * from "./TextFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports